// extracted by mini-css-extract-plugin
export default {"wrapper":"lastUsedBadge_wrapper__+2nWi","lastUsedBadge":"lastUsedBadge_lastUsedBadge__TTIfC"};